export default (vent1: number, vent2: number) => {
  return Math.sqrt(Math.pow(vent1, 2) + Math.pow(vent2, 2));
};
